
export class NumberOfUsersRequestModel {
  // 抽選商品当選数
  public winningGoodsNum: number = <number>0;
}
